import { normalize } from "normalizr";
import { camelizeKeys } from "humps";
import api from "./api";
import { showError } from "actions/actionCreators/snackbarActions";
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from "actions/actionCreators/httpActions";
import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";
import schemas from "utils/schemas";

export function loadOffers(documentId, siteId) {
  return async (dispatch, getState) => {
    const item = getState().document.contractGeneration;
    let shouldCallApi = !item || (!item.isLoaded && !item.loading);
    if (!shouldCallApi) return;
    dispatch({ type: actionTypes.LOAD_FINANCED_OFFERS_FOR_CONTRACT_GENERATION_STARTED });
    try {
      let response = await dispatch(sendHttpRequest(api.loadFolderOffers(documentId, siteId)));
      const camelizedJson = camelizeKeys(response);

      const payload = Object.assign({}, normalize(camelizedJson, [schemas.contractGeneration]));

      dispatch({ type: actionTypes.LOAD_FINANCED_OFFERS_FOR_CONTRACT_GENERATION_SUCCEEDED, ...payload });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_FINANCED_OFFERS_FOR_CONTRACT_GENERATION_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function generateContract(documentId, siteId, assets, generateSeparateContracts) {
  return async dispatch => {
    dispatch({ type: eventTypes.GENERATE_CONTRACT_FOR_DETAILS_EXECUTED });
    try {
      const event = dispatch(
        sendHttpCommandAndWaitForEvent(
          api.generateContract(documentId, siteId, assets, generateSeparateContracts),
          "GenerateContract",
          [eventTypes.GENERATE_CONTRACT_FOR_DETAILS_EXECUTED]
        )
      );

      if (event.ok) {
        dispatch({ type: eventTypes.GENERATE_CONTRACT_FOR_DETAILS_EXECUTED });
      }

      return event;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
